import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Card,
  Typography,
  Pagination,
  message,
  Empty,
  Popconfirm,
  Switch,
} from "antd";
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  MenuOutlined,
  FileTextOutlined,
  SaveTwoTone,
  RetweetOutlined,
  DeleteTwoTone,
  SwapOutlined,
} from "@ant-design/icons";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../../api/Axios";
import AddCourseStep from "../../../../components/AdminComponents/Modals/AddCourseStep";
import LMSContent from "../../../../components/AdminComponents/Modals/LMSContent";
import FilePreviewModal from "../../../../components/FilePreviewModal";
import { capitalizeWords } from "../../../../components/icons/ApplicationColor";
import EditableImage from "../../../../components/icons/EditIcon";
import LMSContentEdit from "../../../../components/AdminComponents/Modals/LMSContentEdit";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";

const { Title } = Typography;

const CourseContent = ({ data1, loading, LoadUser, ImpersonateAccess }) => {
  const { id } = useParams();

  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  // const [dataSource, setDataSource] = useState([]);
  const [stepsMoved, setStepsMoved] = useState(false);
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const isELearning = data1?.mode === "E-Learning";
  const handleCancel = () => {
    setVisible(false);
    setEditVisible(false);
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const {
    data,
    itemsLength,
    loading: loading2,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/coursedetailslist/${id}/`,
    loadAgain: loadAgain,
    // includeStatus: false,
  });
  const [dataSource, setDataSource] = useState(data || []);
  useEffect(() => {
    setDataSource(data);
  }, [data]);
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const handleSubmit = async (values) => {
    try {
      await axiosInstance.put(`/coursedetailssort/?course_id=${id}`, values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      CreateSuccessfull("Step Order Updated");
    } catch (err) {
      CreateFailed("Step Order Update Failed", err);
    }
  };
  const [editData, setEditData] = useState();
  const [editVisible, setEditVisible] = useState(false);
  const SortableItem = ({ children, ...props }) => {
    const id = props["data-row-key"];

    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id });

    const style = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && {
          ...transform,
          scaleY: 1,
        }
      ),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 9999,
          }
        : {}),
    };

    return (
      <tr {...props} ref={setNodeRef} style={style} {...attributes}>
        {React.Children.map(children, (child) => {
          if (child.key === "sort") {
            return React.cloneElement(child, {
              children: (
                <MenuOutlined
                  ref={setActivatorNodeRef}
                  style={{
                    touchAction: "none",
                    cursor: "move",
                    color: "blue",
                  }}
                  {...listeners}
                />
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };

  const onDragEnd = ({ active, over }) => {
    console.log(active, over);
    if (active.id !== over?.id) {
      setStepsMoved(true);
      setDataSource((previous) => {
        const activeIndex = previous.findIndex((i) => i.id === active.id);
        const overIndex = previous.findIndex((i) => i.id === over?.id);
        return arrayMove(previous, activeIndex, overIndex);
      });
    }
  };

  const stepSort = () => {
    const data = {
      ids: dataSource?.map((item) => item.id),
    };

    console.log(data);
    handleSubmit(data);
    setStepsMoved(false);
  };

  const handleRowClick = (record) => {
    //console.log(record);
    setEditData(record);
    setEditVisible(true);
  };

  const onFinishEdit = async (values, passStatus) => {
    const { status, ...cleanedValues } = values;
    const additionalValues = {
      status: passStatus,
    };
    const newValues = { ...cleanedValues, ...additionalValues };
    try {
      await axiosInstance.put(`/coursedetails/?id=${values?.id}`, newValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      handleCancel();
      CreateSuccessfull("Course step Archived Successfully");
    } catch (err) {
      CreateFailed("Course Step Archive Failed", err);
    }
  };
  const columns = [
    ...(ImpersonateAccess
      ? [{ title: "", key: "sort", width: 50, align: "center" }]
      : []),
    { title: "Step Name", dataIndex: "name", key: "name", width: 200 },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 300,
    },
    { title: "Type", dataIndex: "type", key: "type", width: 120 },
    {
      title: "Attachments",
      dataIndex: "attachment",
      key: "attachment",
      width: 150,
      align: "center",
      render: (attachments, record) => {
        if (Array.isArray(attachments) && attachments.length > 0) {
          return (
            <>
              {attachments.map((item, index) => (
                <FileTextOutlined
                  key={index}
                  style={{
                    fontSize: "1.5rem",
                    cursor: "pointer",
                    marginRight: 8,
                  }}
                  onClick={() =>
                    handlePreview(
                      record?.type === "SCORM" ? item?.file_name : item.url,
                      record
                    )
                  }
                />
              ))}
            </>
          );
        }
        return "--";
      },
    },
    ...(ImpersonateAccess
      ? [
          {
            title: capitalizeWords("actions"),
            dataIndex: "actions",
            key: "actions",
            align: "center",
            width: 120,
            fixed: "right",
            render: (text, record) =>
              active ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <EditableImage
                    handleRowClick={handleRowClick}
                    recordId={record}
                    size="small"
                  />
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Popconfirm
                      title={"Archive Course Step"}
                      description=" "
                      onConfirm={() => {
                        onFinishEdit(record, false);
                      }}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      placement="leftTop"
                    >
                      <DeleteTwoTone
                        key="delete"
                        style={{
                          cursor: "pointer",
                          fontSize: "1.6rem",
                          marginLeft: "0.9rem",
                        }}
                        title="delete"
                        twoToneColor="#eb2f96"
                      />
                    </Popconfirm>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Popconfirm
                      title={"UnArchive Course Step"}
                      description=" "
                      onConfirm={() => {
                        onFinishEdit(record, true);
                      }}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      placement="leftTop"
                    >
                      <SwapOutlined
                        key="delete"
                        style={{
                          cursor: "pointer",
                          fontSize: "1.6rem",
                        }}
                        title="delete"
                      />
                    </Popconfirm>
                  </div>
                </div>
              ),
          },
        ]
      : []),
  ];
  const showModal = () => {
    setVisible(true);
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: props,
      duration: 5,
    });
    LoadAPI();
  };
  const CreateFailed = (props, err) => {
    const messageApi = message;

    const errorMessage = err?.response?.data?.detail?.non_field_errors?.[0];

    messageApi.open({
      type: "error",
      content: errorMessage || props,
      duration: 5,
    });
  };
  const [previewVisible, setPreviewVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedRecord, setSelectedRecord] = useState();
  const handlePreview = (fileUrl, record) => {
    setSelectedFile(fileUrl);
    setPreviewVisible(true);
    setSelectedRecord(record);
  };

  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}

      <Title level={5} style={{ marginInline: "10px", letterSpacing: "0.5px" }}>
        Course Steps Summary
      </Title>
      <CommonTopDetails
        title={`Program Schedule`}
        titleSuffix={`${itemsLength} step(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        showAddButton={ImpersonateAccess}
        addButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        customContent={
          <>
            {stepsMoved && (
              <>
                <Button
                  icon={<RetweetOutlined />}
                  onClick={() => {
                    setDataSource(data);
                    setStepsMoved(false);
                  }}
                >
                  Reset
                </Button>
                <Button icon={<SaveTwoTone />} onClick={stepSort}>
                  Save Order
                </Button>
              </>
            )}
            {!isELearning && (
              <Switch
                style={{
                  backgroundColor: active ? "#50C878" : "#FF0000",
                  minWidth: "80px",
                }}
                checked={active}
                disabled={loading}
                onChange={handleSwitchChange}
                checkedChildren="Active"
                unCheckedChildren="Inactive"
              />
            )}
          </>
        }
      />
      {dataSource.length > 0 ? (
        <>
          <DndContext
            sensors={sensors}
            onDragEnd={onDragEnd}
            style={{ zIndex: dataSource.length === 0 ? 0 : 1 }}
          >
            <SortableContext
              items={dataSource.map((i) => i.id)}
              strategy={verticalListSortingStrategy}
            >
              <Table
                dataSource={dataSource}
                columns={columns}
                bordered
                rowKey="id"
                size="small"
                loading={loading2}
                className="table-container"
                style={{
                  marginInline: "1rem",
                  zIndex: data.length === 0 ? 0 : 1,
                }}
                locale={{ emptyText: "No Data Available" }}
                pagination={false}
                components={
                  ImpersonateAccess && {
                    body: {
                      row: SortableItem,
                    },
                  }
                }
              />
            </SortableContext>
          </DndContext>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <Pagination
              size="small"
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onPageChange}
              pageSizeOptions={["5", "10", "15", "20", "50"]}
              //   showQuickJumper
              current={currentPage}
              defaultPageSize={pageSize}
              total={itemsLength}
            />
          </div>
        </>
      ) : (
        <Empty />
      )}

      {isELearning ? (
        <LMSContent
          visible={visible}
          onCancel={handleCancel}
          id={id}
          CreateSuccessfull={CreateSuccessfull}
          CreateFailed={CreateFailed}
          data1={data1}
          LoadUser={LoadUser}
        />
      ) : (
        <>
          <AddCourseStep
            visible={visible}
            onCancel={handleCancel}
            id={id}
            CreateSuccessfull={CreateSuccessfull}
            CreateFailed={CreateFailed}
          />
          <AddCourseStep
            visible={editVisible}
            onCancel={handleCancel}
            id={id}
            CreateSuccessfull={CreateSuccessfull}
            CreateFailed={CreateFailed}
            type="edit"
            initialValues={editData}
          />
        </>
      )}
      {isELearning && (
        <LMSContentEdit
          visible={editVisible}
          onCancel={handleCancel}
          id={id}
          CreateSuccessfull={CreateSuccessfull}
          CreateFailed={CreateFailed}
          editData={editData}
          data1={data1}
          LoadUser={LoadUser}
        />
      )}

      <FilePreviewModal
        open={previewVisible}
        onClose={() => setPreviewVisible(false)}
        fileUrl={selectedFile}
        selectedRecord={selectedRecord}
      />
    </Card>
  );
};

export default CourseContent;
